import { DotsRadioGroupModel } from "dots-ui/dotsRadioGroup";
import { DotsRadioGroup } from "dots-ui/dotsRadioGroup";
import { FormikProps } from "formik";
import { useMemo } from "react";
import useDeviceDetection, { AvisDevice } from "../../../../hooks/useDevice";
interface IAvisValueRowProps<T> {
  rowTitle?: string;
  rowValueLabelYes?: string;
  rowValueLabelNo?: string;
  bag: FormikProps<T>;
  bagFieldIn: keyof T;
  isReadOnly?: boolean;
}
export function AvisHorizontalChoice<T>(
  props: Readonly<IAvisValueRowProps<T>>,
) {
  const {
    rowTitle,
    rowValueLabelYes,
    rowValueLabelNo,
    bag,
    bagFieldIn,
    isReadOnly,
  } = props;
  const device = useDeviceDetection();

  const isTabletOrMobileScreen = useMemo(() => {
    if (device === undefined) return false;

    return device !== AvisDevice.desktop;
  }, [device]);

  const model1: DotsRadioGroupModel<boolean> = [
    {
      value: true,
      label: rowValueLabelYes,
    },
    {
      value: false,
      label: rowValueLabelNo,
    },
  ];

  return (
    <div className="avis-horizontal-choice">
      <div className="row-title">{rowTitle}</div>
      <div className="row-value">
        <DotsRadioGroup<boolean, T>
          view={isTabletOrMobileScreen ? "list" : "row"}
          model={model1}
          disabled={isReadOnly}
          bag={bag}
          bagField={bagFieldIn}
        />
      </div>
    </div>
  );
}
